import {ValueObject} from '@s-ui/domain'

export class UpdateReservationPhoneNumberTransactionsRequest extends ValueObject {
  /**
   * @param {String} buyerPaymentPhone
   **/

  #buyerPaymentPhone
  #reservationId

  static create({buyerPaymentPhone, reservationId}) {
    return new UpdateReservationPhoneNumberTransactionsRequest({buyerPaymentPhone, reservationId})
  }

  constructor({buyerPaymentPhone, reservationId}) {
    super()
    this.#buyerPaymentPhone = buyerPaymentPhone
    this.#reservationId = reservationId
  }

  get buyerPaymentPhone() {
    return this.#buyerPaymentPhone
  }

  get reservationId() {
    return this.#reservationId
  }

  toJSON() {
    return {
      buyerPaymentPhone: this.#buyerPaymentPhone,
      reservationId: this.#reservationId
    }
  }
}
